module.exports = __webpack_public_path__ + "img/0726_V0A.660e7966.jpg";